// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2P6Dv","actions":"GroupTable_actions__21jxl","deleteModalFooter":"GroupTable_deleteModalFooter__2fJme"};